module.exports = __webpack_public_path__ + "static/assets/fe66695c969ae21821ed6c5072622544.png";